import { handleRequest } from '@/utils';

import { FAKE_SESSION_ID } from './constants';

export enum TransferType {
  ToLiveAgent = 1,
  ToWebform = 2,
  ToCall = 3,
}

export async function reportTransferType({
  sessionId,
  transferType,
}: {
  sessionId: string;
  transferType: TransferType;
}) {
  if (sessionId === FAKE_SESSION_ID || !sessionId) {
    return;
  }

  const res = await handleRequest('reportTransferType', {
    session_id: sessionId,
    transfer_type: transferType,
  });
  if (res === undefined) {
    // 重试一次
    setTimeout(() => {
      handleRequest('reportTransferType', {
        session_id: sessionId,
        transfer_type: transferType,
      });
    }, 1000);
  }
}
